module.exports = __webpack_public_path__ + "img/pellets-mobile.1de633b.webp";